import { PRODUCTS } from '../config/columns.config';

const sumProducts = (obj = {}) =>
  PRODUCTS.reduce((sum, p) => sum + (obj[p.key] || 0), 0);

export const accumulateProducts = (target, source = {}) => {
  PRODUCTS.forEach(p => {
    target[p.key] = (target[p.key] || 0) + (source[p.key] || 0);
  });
};

export const accumulateAccount = (account, totals, config) => {

  accumulateProducts(totals.retailOnly, account.retail);
  accumulateProducts(totals.showroomOnly, account.showroom);

  (account.projects || []).forEach(project => {
    if (!project.isHidden) {
        accumulateProducts(totals.project, project);
        const pTotal = (project.total !== undefined) ? project.total : sumProducts(project);
        totals.explicitProjectTotal = (totals.explicitProjectTotal || 0) + pTotal;
    }
  });

  if (config?.budgetType) {
    totals.budget +=
      config.budgetType === 'internal'
        ? account.internalBudget || 0
        : account.externalBudget || 0;
    totals.retailBudget = (totals.retailBudget || 0) + (account.retailBudget || 0);
    totals.projectBudget = (totals.projectBudget || 0) + (account.projectBudget || 0);
  }

  (account.subAccounts || []).forEach(sub =>
    accumulateAccount(sub, totals, config)
  );
};

export const calculateAccountTotals = (account, config) => {
  const totals = {
    retailOnly: Object.fromEntries(PRODUCTS.map(p => [p.key, 0])),
    showroomOnly: Object.fromEntries(PRODUCTS.map(p => [p.key, 0])),
    project: Object.fromEntries(PRODUCTS.map(p => [p.key, 0])),
    explicitProjectTotal: 0,
    budget: 0,
    retailBudget: 0,
    projectBudget: 0,
  };

  accumulateAccount(account, totals, config);

  const retailOnlyTotal = sumProducts(totals.retailOnly);
  const showroomOnlyTotal = sumProducts(totals.showroomOnly);
  
  const retail = {};
  PRODUCTS.forEach(p => {
      retail[p.key] = totals.retailOnly[p.key] + totals.showroomOnly[p.key];
  });

  const retailTotal = retailOnlyTotal + showroomOnlyTotal;
  const projectTotal = totals.explicitProjectTotal;
  const grandTotal = retailTotal + projectTotal;

  return {
    ...totals,
    retail, 
    retailOnlyTotal,
    showroomOnlyTotal,
    retailTotal,
    projectTotal,
    grandTotal,
  };
};

export const calculateSalesTotals = (data, config) => {
  const totals = {
    retailOnly: Object.fromEntries(PRODUCTS.map(p => [p.key, 0])),
    showroomOnly: Object.fromEntries(PRODUCTS.map(p => [p.key, 0])),
    project: Object.fromEntries(PRODUCTS.map(p => [p.key, 0])),
    explicitProjectTotal: 0,
    budget: 0,
    retailBudget: 0,
    projectBudget: 0,
    grandTotal: 0,
  };

  data.forEach(account =>
    accumulateAccount(account, totals, config)
  );

  const retailOnlyTotal = sumProducts(totals.retailOnly);
  const showroomOnlyTotal = sumProducts(totals.showroomOnly);
  const retailTotal = retailOnlyTotal + showroomOnlyTotal;
  const projectTotal = totals.explicitProjectTotal;
  const grandTotal = retailTotal + projectTotal;

  const combinedRetail = {};
  PRODUCTS.forEach(p => {
      combinedRetail[p.key] = totals.retailOnly[p.key] + totals.showroomOnly[p.key];
  });

  return {
      retail: combinedRetail, 
      project: totals.project,
      retailTotal,
      projectTotal,
      grandTotal,
      budget: totals.budget,
      retailBudget: totals.retailBudget,
      projectBudget: totals.projectBudget
  };
};

export const calculatePurchaseTotals = (data) => {
  return calculateSalesTotals(data, { reportCategory: 'purchase' });
};